import { getStakeholderProfileData } from 'lib/api/business';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import CreditTables from './components/CreditTables';
import FactoringTables from './components/FactoringTables';
import OthersSummary, {
  BankruptcyData,
  BuroData,
  DebtData,
} from './components/OthersSummary';
import ProductSummary from './components/ProductSummary';

interface StakeholderProfileProps {
  businessId: string | null;
}

interface DocumentData {
  folio: string;
  operationId: string;
  businessName: string;
  businessIdentifier: string;
  fundName: string;
  amount: number;
  amountConciliated: number;
  documentRemainingAmountNet: number;
  arrearAmount: number;
  totalRemainingNet: number;
  issuedDate: string;
  paymentDate: string;
  arrearTrench?: string;
  arrearDays?: number;
  paidAt?: string;
}
interface ProductData {
  payDaysAverage?: number;
  operationDatePayDaysAverage?: number;
  documentsTotal?: number;
  documentsPaid?: number;
  amountTotal?: number;
  amountPaid?: number;
  onDateDocuments: DocumentData[];
  inArrearDocuments: DocumentData[];
  paidDocuments: DocumentData[];
}

interface StakeholderProfileData {
  factoringData: ProductData;
  confirmingData: ProductData;
  creditData: ProductData;
  buroData: BuroData | null;
  bankruptcyData: BankruptcyData[];
  debtData: DebtData | null;
}

const StakeholderProfile = (props: StakeholderProfileProps) => {
  const { businessId } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<StakeholderProfileData | null>(null);

  const setUp = async () => {
    setLoading(true);
    try {
      if (!businessId) return;
      const data = await getStakeholderProfileData(dispatch, businessId);
      setData(data);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener el perfil');
    }
    setLoading(false);
  };

  useEffect(() => {
    void setUp();
  }, [businessId]);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  if (!data) return null;

  return (
    <div
      style={{
        maxHeight: '400px',
        overflow: 'auto',
        paddingBottom: '20px',
      }}
    >
      <OthersSummary
        buroData={data.buroData}
        bankruptcyData={data.bankruptcyData}
        debtData={data.debtData}
      />
      <ProductSummary data={data.factoringData} productName="Factoring" />
      <FactoringTables data={data.factoringData} />
      <ProductSummary data={data.confirmingData} productName="Confirming" />
      <FactoringTables data={data.confirmingData} />
      <ProductSummary data={data.creditData} productName="Créditos" />
      <CreditTables data={data.creditData} />
    </div>
  );
};

export default StakeholderProfile;
